// LoadingAnimation.js
import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from './lotties/osorio-loading.json';

const LoadingAnimation = () => {
    return (
        <div className="flex-grow flex justify-center mt-20 z-30">
            <Player
                autoplay
                loop
                src={animationData}
                style={{ height: '300px', width: '900px' }}
            />
        </div>
    );
};

export default LoadingAnimation;
